import { CanActivateFn } from '@angular/router';
import { chainGuardFns } from './chain-guard-fns.util';

export const chainCanActivateFns =
  (...guards: CanActivateFn[]): CanActivateFn =>
  (route, state) =>
    chainGuardFns(guard => guard(route, state), guards);
